import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({

}));


function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix="$"
    />
  );
}

export default function NumberInput(props) {
  const classes = useStyles();
  const { MinValue, MaxValue, OnInputChange, onValidationChange } = props;
  const [isValidAmount, setIsValidAmount] = useState(true);

  const onChangeHandler = (event) => {
    if (MinValue && MaxValue) {
      if (parseFloat(event.target.value) < MinValue || parseFloat(event.target.value) > MaxValue) {
        setIsValidAmount(false);
      }
      else {
        setIsValidAmount(true);
      }
    }

    OnInputChange(event);
  }

  useEffect(() => {
    onValidationChange(isValidAmount)
  }, [isValidAmount])

  return (
    <div>
    <TextField
      {...props}
      error={!isValidAmount}
      onChange={onChangeHandler}
      InputProps={{
        inputComponent: NumberFormatCustom,
      }}
    />
    </div>
  );
}

NumberInput.propTypes = {
  MinValue: PropTypes.number,
  MaxValue: PropTypes.number,
  onValidationChange: PropTypes.func,
  OnInputChange: PropTypes.func.isRequired,
};